import React from 'react';
import UserListItem from 'components/UserListItem';
import NoResultsInvitePrompt from 'components/NoResultsInvitePrompt';
import InviteUserItem from 'components/InviteUserItem';

const UserList = ({isSearch, userIds, selected, onClick}) => {
  const items = userIds.map(id => (
    <UserListItem
      userId={id}
      key={id}
      onClick={onClick.bind(null, id)}
      selected={selected.has(id)}
    />
  ));

  return isSearch && userIds.length === 0 ? (
    <NoResultsInvitePrompt />
  ) : (
    <div>
      {isSearch ? null : <InviteUserItem />}
      {items}
    </div>
  );
};

export default UserList;
